import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';

let headers = {};

let BACKEND_URL = 'https://mobi-api.aventusinformatics.com/'
// let BACKEND_URL = 'https://uat-api.mobicom.com/'

const domain = window.location.hostname;
// const domainWithoutProtocol = domain.replace(/^https?:\/\//, '');

// console.log(domainWithoutProtocol);

// console.log(domain);


if (domain === "uat.mobicom.com") {

    BACKEND_URL = 'https://uat-api.mobicom.com/';
}
else if (domain === 'email.mobicom.com') {
    BACKEND_URL = 'https://email-api.mobicom.com/';
}
else if (domain === 'email-blast.aventusinformatics.com') {
    BACKEND_URL = 'https://email-blast-api.aventusinformatics.com/';
}
else {
    // BACKEND_URL = 'https://email-api.mobicom.com/';
    BACKEND_URL = 'https://email-blast-api.aventusinformatics.com/';
    // BACKEND_URL = 'http://192.168.0.147:5000/';
}






const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers
});


axiosInstance.interceptors.request.use(
    async (config) => {
        const token = reactLocalStorage.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

const refreshAuthToken = async () => {
    try {
        const refreshToken = reactLocalStorage.get('refresh_token');
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }

        const response = await axios.post(`${BACKEND_URL}refresh_token`, {
            refresh_token: refreshToken,
        });

        const { access_token, refresh_token } = response.data;
        reactLocalStorage.set('token', access_token);
        reactLocalStorage.set('refresh_token', refresh_token);

        return access_token;
    } catch (error) {
        console.error('Failed to refresh token', error);
        throw error;
    }
};

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const newToken = await refreshAuthToken();

                axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

                return axiosInstance(originalRequest);
            } catch (refreshError) {
                console.error('Token refresh failed', refreshError);

                reactLocalStorage.remove('token');
                reactLocalStorage.remove('refresh_token');

                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
